import React from "react";
import { Layout, Header, Navigation, Drawer, Content } from "react-mdl";
import Main from "./main";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

function MainLayout() {
  return (
    <Layout>
      <Header
        id="hamMenu"
        className="hamMenu"
        title="J. SEBASTIÁN RODRÍGUEZ GALARZA"
        scroll
      >
        <Navigation>
          <HashLink to="/#landing" smooth={true} className="link">
            Home
          </HashLink>
          <HashLink to="/#aboutMe" smooth={true} className="link">
            About Me
          </HashLink>
          <HashLink to="/#resume" smooth={true} className="link">
            Resume
          </HashLink>
          <HashLink to="/projects" smooth={true} className="link">
            Projects
          </HashLink>
        </Navigation>
      </Header>
      <Drawer>
        <Navigation>
          <HashLink to="/#landing" smooth={true}>
            Home
          </HashLink>
          <HashLink to="/#aboutMe" smooth={true}>
            About Me
          </HashLink>
          <HashLink to="/#resume" smooth={true}>
            Resume
          </HashLink>
          <HashLink to="/projects" smooth={true}>
            Projects
          </HashLink>
        </Navigation>
      </Drawer>
      <Content className="content">
        <Main />
      </Content>
    </Layout>
  );
}

export default MainLayout;
